import React from 'react'
import bg from '../../images/background/pattern-6.png'
import bg2 from '../../images/background/pattern-10.png'

import { Link } from 'react-router-dom'

const WhyAttendS2 = (props) => {

    const Service = [
        {
            title: 'Real Connections, Not Just Contacts',
            des: 'Skip the small talk. Meet people who actually get you — from industry experts to everyday professionals.',
            // icon: 'flaticon-connection'
        },
        {
            title: 'Skill-Up Without the Snooze',
            des: 'Workshops that don’t feel like lectures. Learn modern workplace skills through interactive, fun, and practical sessions.',
            // icon: 'flaticon-book'
        },
        {
            title: 'Mental Wellness That Makes Sense',
            des: 'We keep it real. No fluff, no jargon — just simple tools and spaces to breathe, reflect, and recharge.',
            // icon: 'flaticon-idea'
        }
        ,
        {
            title: 'Events That Energize, Not Exhaust',
            des: 'From mindful meet-ups to power-packed panels — every event is designed to inspire, not overwhelm.',
            // icon: 'flaticon-idea'
        },
        {
            title: 'A Safe Space to Just Be You',
            des: 'Judgment-free zone alert! Share ideas, ask questions, or just listen — all at your own pace.',
            // icon: 'flaticon-idea'
        },
        {
            title: 'Grow Your Network, Organically',
            des: 'No forced DMs. No awkward intros. Just good conversations that can lead to great opportunities.',
            // icon: 'flaticon-idea'
        }
        
    ]

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    return (

        <section className="services-one">
            <div className="services-one_pattern-one" style={{ backgroundImage: `url(${bg})` }}></div>
            <div className="services-one_pattern-two" style={{ backgroundImage: `url(${bg2})` }}></div>
            <div className="auto-container">
                <div className="sec-title centered title-anim">
                    <div className="sec-title_title">Join The Community</div>
                    <h2 className="sec-title_heading">Why Join The Lush Minds?</h2>
                </div>
                <div className="row clearfix">
                    {Service.map((service, sitem) => (
                        <div className="service-block_one col-lg-4 col-md-6 col-sm-12" key={sitem}>
                            <div className="service-block_one-inner">
                                <div className={`service-block_one-icon fi ${service.icon}`}></div>
                                <h4 className="service-block_one-heading">{service.title}</h4>
                                <div className="service-block_one-text">{service.des}</div>
                            </div>
                        </div>
                    ))}

                </div>
            </div>
        </section>

    )
}

export default WhyAttendS2;